import { memo } from 'react';
import { Switch as RACSwitch, SwitchProps as RACSwitchProps } from 'react-aria-components';

import { merge } from '@/components';

export type SwitchProps = RACSwitchProps & {
  indicatorClassName?: string;
};

const ISwitch = ({ className, indicatorClassName, children, ...rest }: SwitchProps) => {
  // eslint-disable-next-line prettier/prettier
  const styles = [
    'flex',
    'group/control',
    'cursor-pointer',
    'items-center',
    'gap-sm',
  ];
  const lightStyles = ['text-gray-900'];

  const indicatorStyles = [
    'flex',
    'items-center',
    'rounded-full',
    'group-data-[selected]/control:bg-primary-600',
    'bg-gray-200',
    'p-[0.05rem]',
    'w-[1.5rem]',
    'border-1',
    'border-gray-300',
  ];

  return (
    <RACSwitch className={merge(styles, lightStyles, className)} {...rest}>
      <>
        <div className={merge(indicatorStyles, indicatorClassName)}>
          <span className="size-[0.70rem] rounded-full bg-white transition duration-200 ease-in-out group-data-[selected]/control:translate-x-[80%]" />
        </div>
        {children}
      </>
    </RACSwitch>
  );
};

export const Switch = memo(ISwitch) as typeof ISwitch;
